import React, { Component } from "react";

class Barcode extends Component {
  componentDidMount() {
    import("./barcodeFont.scss");
  }

  render() {
    const { imbarcode } = this.props.hoData;
    return (
      <div>
        <div className="barcode">{imbarcode}</div>
      </div>
    );
  }
}

export default Barcode;
